import { useEffect, useState } from 'react'
import {
  Dialog,
  DialogTitle,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  FormHelperText,
  Box,
  Button,
  DialogContent,
  Typography
} from '@mui/material'
import { User } from '../../services/Types'
import { useAllUsers } from '../../hooks/useAllUsers'
import { dialogButtons } from '../../global'

interface NewApproverProps {
  open: boolean
  onSave: (userId: number) => void
  onCancel: () => void
  currentApprover: User
}

export const DialogNewApprover = ({
  open,
  onSave,
  onCancel,
  currentApprover
}: NewApproverProps) => {
  const [selectedApprover, setSelectedApprover] = useState<number>(0)
  const [error, setError] = useState('')
  const { allApproverUsers } = useAllUsers()

  const handleChange = (event: SelectChangeEvent) => {
    setSelectedApprover(Number(event.target.value))
    setError('')
  }

  const handleCancel = () => {
    document.body.focus()
    setSelectedApprover(0)
    onCancel()
  }

  const handleSave = () => {
    if (selectedApprover === 0) {
      setError('Please select a new approver')
      return
    }
    document.body.focus()
    onSave(selectedApprover)
  }

  return (
    <Dialog
      open={open}
      disableEnforceFocus
      disableAutoFocus
    >
      <DialogTitle>Select New Approver</DialogTitle>
      <DialogContent>
        <Typography>
          {currentApprover.firstName} {currentApprover.lastName} has some pending event approvals. Please select a new approver to replace them.
        </Typography>
      </DialogContent>
      <Box sx={{ p: 2 }}>
        <FormControl
          fullWidth
          error={Boolean(error)}
        >
          <InputLabel>New Approver</InputLabel>
          <Select
            value={selectedApprover.toString()}
            onChange={handleChange}
            label="New Approver"
          >
            <MenuItem disabled value={0}>Select</MenuItem>
            {allApproverUsers(currentApprover.programOffice?.id ?? 0, currentApprover.approverLevel ?? 1)
              .filter(approver => approver.id !== currentApprover.id)
              .map(approver => (
                <MenuItem key={approver.id} value={approver.id}>
                  {approver.firstName} {approver.lastName}
                </MenuItem>
              ))
            }
          </Select>
          {error && <FormHelperText>{error}</FormHelperText>}
        </FormControl>

        <Box style={dialogButtons}>
          <Button
            variant="outlined"
            color="primary"
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSave}
          >
            Save
          </Button>
        </Box>
      </Box>
    </Dialog>
  )
}
